import './App.css';
import Footer from './Component/Footer/Footer';
import Navbar from './Component/Navbar/Navbar';
import Home from './Pages/Home';

function App() {
  return (
 <>
     <Navbar/>
     <Home/>
     <Footer/>
     </>
  );
}

export default App;
